<div class="filter-date-picker">
	<!-- TODO DATERANGEPICKER -->
	<!-- <input
		type="text"
		name="daterangeInput"
		class="form-control"
		[value]="currentDateRange"
		daterangepicker
		[options]="rangePickerOptions"
		(selected)="selectedDate($event)"
	/> -->
</div>
